import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { NamedWebhooksIntegration } from "types/generated";
import SpacePath from "components/SpacePath";

const WebhooksTableSpaceCell = ({
  item: webhook,
  ...cellProps
}: TableSimpleCellProps<NamedWebhooksIntegration>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <SpacePath spaceId={webhook.space.id} fallbackName={webhook.space.name} />
    </TableSimpleCell>
  );
};

export default WebhooksTableSpaceCell;
